<svelte:options runes={false} />

<script>
  export let selectedProject;
  export let projectName;
  export let savingProjectName;
  export let onSaveProjectName;
</script>

<div class="project-directory">
  <h3>Project name</h3>

  {#if selectedProject}
    <label>
      Project name
      <input bind:value={projectName} maxlength="120" />
    </label>
    <!-- The button is not disabled on an empty field: pressing it says what is
         missing. It disables while its call is in flight so a second press
         cannot race the first rename. -->
    <button type="button" disabled={savingProjectName} on:click={onSaveProjectName}>
      {savingProjectName ? 'Saving name…' : 'Save project name'}
    </button>
    <p class="quiet">
      This renames the selected project. Its invoices and their links are left
      exactly as they are.
    </p>
  {/if}
</div>
